module.exports = __webpack_public_path__ + "img/business-strategy-development.7621ec5d.svg";